import { DialogDataAttrs } from "../dialog/data.js";
//#region src/core/ui/error-dialog/data.ts
/** @internal */
const ErrorDialogDataAttrs = { ...DialogDataAttrs };
//#endregion
export { ErrorDialogDataAttrs };
